<p-select
    [options]="availableLocales"
    [(ngModel)]="selectedLocale"
    (onChange)="handleLanguageChange($event.value)"
    [ariaLabel]="'menu.shell.language' | translate"
    appendTo="body">
    @if (selectedLocale) {
        <ng-template pTemplate="selectedItem">
            <span class="font-medium">{{ selectedLocale | uppercase }}</span>
        </ng-template>
    }
    <ng-template let-locale pTemplate="item">
        <span [attr.title]="'common.languages.' + locale | translate">{{ locale | uppercase }}</span>
    </ng-template>
</p-select>
